import { Wishlist } from "../../../../api/backend/backend-api"
import { UserWishlist } from "../wishlistTypes"

export const toWishlist = (wishlist: Wishlist): UserWishlist => ({
  id: wishlist.id,
  items: wishlist.items,
})
